/**
 * The one date format this backend accepts in a request body.
 *
 * `yyyy-MM-dd HH:mm:ss`, with **no timezone**. Sending ISO-8601 fails outright:
 *
 *     JSON parse error: Cannot deserialize value of type `java.util.Date` from
 *     String "2026-08-18T19:00:00.000Z": expected format "yyyy-MM-dd HH:mm:ss"
 *
 * The API documentation says ISO-8601 or epoch milliseconds are accepted for these
 * fields. They are not — Jackson is configured with that pattern, so anything else
 * is a 400 before the controller is reached. Responses are the other way round and
 * do come back as ISO with an offset (`2026-08-19T11:30:00.000+05:00`), which
 * `new Date()` parses correctly, so only the request direction needs this.
 *
 * THE OTHER HALF OF THE BUG. Because the format carries no zone, the server reads
 * it in its own, which is the operation's. So the wall clock has to travel
 * unchanged. `toISOString()` — the obvious way to serialize a Date — converts to
 * UTC first, and the error above shows what that costs: a request for 19 August
 * 00:00 in Almaty left as 18 August 19:00Z, five hours into the previous day. Even
 * if the format had been accepted, the day would have been wrong.
 */

const pad = (value: number): string => String(value).padStart(2, '0');

/**
 * A local wall clock, in the shape the backend parses.
 *
 * Accepts a Date or a `datetime-local` value (`2026-08-19T00:00`) — which is what
 * the table keeps in its URL — and reads only the local components, so nothing is
 * shifted between zones.
 */
export const toApiDateTime = (value: Date | string): string => {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '';

  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

  return `${day} ${time}`;
};
